// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AnnotationIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AnnotationIcon" ref={forwardedRef} {...props}>
      <path d="M16 18H4v-1.5h12z" />
      <path d="M15.103 2.005A1 1 0 0 1 16 3v7.596L10 14.5l-6-3.904V3a1 1 0 0 1 .897-.995L5 2h10zM5.5 9.78l4.5 2.93 4.5-2.929V3.5h-9z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AnnotationIcon = /* @__PURE__ */ Object.assign(
  AnnotationIconComponent,
  { displayName: 'AnnotationIcon' },
);
